export function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-4">
          {/* Phone Number */}
          <div>
            <p className="text-sm font-medium">
              (860) 459-1575
            </p>
          </div>
          
          {/* Address */}
          <div>
            <p className="text-sm">
              94 Wolcott Rd, Simsbury, CT 06070, USA
            </p>
          </div>
          
          {/* Copyright */}
          <div>
            <p className="text-xs text-gray-400">
              ©2025 by Simsbury Airport.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}